// Rewrites the "Limited Edition" line property in the storefront's current language
// when the line was added under another locale (e.g. added in FR, then switched to EN).
// The outdated lines come from snippets/limited-edition-locale-sync.liquid.
if (!window.syncLimitedEditionLocale) {
  let synced = false;

  window.syncLimitedEditionLocale = async () => {
    const cartHelper = window.Alpine?.store('xCartHelper');
    const el = document.querySelector('[data-limited-edition-lines]');
    // Runs once per page load so a failed request can't loop.
    if (synced || !el || !cartHelper) return;
    synced = true;

    let lines;
    try {
      lines = JSON.parse(el.dataset.limitedEditionLines);
    } catch (error) {
      return;
    }

    await cartHelper.waitForCartUpdate();
    window.updatingCart = true;

    const root = window.Shopify?.routes?.root || '/';
    const sections = cartHelper.getSectionsToRender().map((section) => section.id);
    let response;
    try {
      for (const line of lines) {
        const result = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: line.key,
            quantity: line.quantity,
            properties: line.properties,
            sections,
            sections_url: window.location.pathname
          })
        });
        if (result.ok) response = await result.json();
      }
    } catch (error) {
      console.error('Limited Edition locale sync:', error);
    } finally {
      window.updatingCart = false;
      el.remove();
    }

    if (response?.sections) cartHelper.reRenderSections(response.sections);
  };

  if (window.Alpine?.store('xCartHelper')) {
    window.syncLimitedEditionLocale();
  } else {
    document.addEventListener('alpine:initialized', () => window.syncLimitedEditionLocale());
  }
}
